import { createTheme, ThemeOptions, Theme } from '@mui/material/styles';
import { defaultTheme } from 'react-admin';

export const APP_COLOR_PRIMARY = '#3F51B5';
export const APP_COLOR_SECONDARY = '#22263D';

const themeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: APP_COLOR_PRIMARY,
        },
        secondary: {
            main: APP_COLOR_SECONDARY,
        },
        custom: {
            nav: 'rgb(66, 66, 66)',
            green: 'rgba(196,214,0,1)',
            gray: 'rgba(0,0,0, 0.1)',
            selected: 'rgba(63, 81, 181, 0.08)',
        },
    },
    typography: {
        body1: {
            color: '#091747',
        },
        fontFamily: 'Open Sans, Arial',
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 16,
                },
            },
        },
        MuiScopedCssBaseline: {
            styleOverrides: {
                root: {
                    background: 'transparent',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: ({}: any) => ({
                    padding: '10px 35px',
                }),
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
            },
        },
    },
};

// En react-admin v5, defaultTheme es un tema completo de Material UI
// Combinamos las opciones personalizadas con el tema por defecto
// Usamos una combinación más profunda para asegurar que todas las propiedades se fusionen correctamente
const mainTheme: Theme = createTheme(
    {
        ...defaultTheme,
        ...themeOptions,
        palette: {
            ...(defaultTheme as Theme).palette,
            ...themeOptions.palette,
        },
        typography: {
            ...(defaultTheme as Theme).typography,
            ...themeOptions.typography,
        },
        components: {
            ...(defaultTheme as Theme).components,
            ...themeOptions.components,
        },
    } as Theme
);

export default mainTheme;
